import styled from 'styled-components';

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 320px;
  padding: 30px 20px;
`;

export const StyledText = styled.p`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  padding-top: 20px;
  margin-top: 0;
  text-align: center;
`;
